import { createID, createRedline } from 'redline-client-sdk';

import { getSafeCookies } from '@public-pages/utils';

import { autoEvents } from '../events/auto';
import { ecommerceEvents } from '../events/ecommerce';
import { experienceEvents } from '../events/experience';
import { sortingHatEvents } from '../events/sortingHat';
import { userTrackingEvents } from '../events/userTracking';
import { userAuthenticationEvents } from '../events/userAuthentication';
import { debtsEvents } from '../events/debts';

export const useRedline = () => {
  const rl = createRedline({
    writeKey: import.meta.env.PUBLIC_REDLINE_WRITE_KEY,
    mode: import.meta.env.PUBLIC_PRODUCTION ? 'prod' : 'dev',
    logs: !import.meta.env.PUBLIC_PRODUCTION,
    appName: import.meta.env.PUBLIC_REDLINE_APPNAME
  });

  function startRedline() {
    rl.start();
  }

  const track = {
    auto: autoEvents(rl),
    ecommerce: ecommerceEvents(rl),
    experience: experienceEvents(rl),
    sortingHat: sortingHatEvents(rl),
    userTracking: userTrackingEvents(rl),
    userAuthentication: userAuthenticationEvents(rl),
    debts: debtsEvents(rl),
  };

  function createCorrelationId(key: string) {
    const correlationId = createID();
    const thirtyMinutes = new Date();
    const getCurrentId = getSafeCookies.getCookie(key);

    if (!getCurrentId) {
      thirtyMinutes.setTime(thirtyMinutes.getTime() + 30 * 60 * 1000);

      getSafeCookies.addCookie({
        key,
        value: correlationId,
        expires: thirtyMinutes,
      });
    }
  }

  function getCorrelationId(key: string) {
    return getSafeCookies.getCookie(key);
  }

  return {
    startRedline,
    track,
    createCorrelationId,
    getCorrelationId,
  };
};
